import React from 'react'
import { Button, Collapse, Divider, Input, Select, Space } from 'antd'
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons'
import { FormComponent } from '../../BaseComponent'
import IQuestionShelter from '../../../interfaces/IQuestionShelter'
import { LanguageConsumer } from '../../../context/LanguageContext'

export type QuestionAskAliasTranslation = {
  ask_alias: string,
  language_id: number
}

export type QuestionAskAlias = {
  ask_alias: string
  translation?: QuestionAskAliasTranslation[]
}

type QuestionAskAliasProps = {
  question: IQuestionShelter
  questionAskAlias: QuestionAskAlias

  onSave: (questionShelter: IQuestionShelter, questionAskAlias: QuestionAskAlias) => void
}

export default class ShelterQuestionAskAlias extends FormComponent<QuestionAskAliasProps> {

  state = {
    questionAskAlias: this.props.questionAskAlias
  }

  private handleAddTranslation = () => {
    const { questionAskAlias } = this.state

    questionAskAlias.translation?.push({
      ask_alias: '',
      language_id: 0
    })

    this.setState({
      questionAskAlias
    })
  }

  private handleRemoveTranslation = (index: number) => {
    const { questionAskAlias } = this.state
    
    this.setState({
      questionAskAlias: {
        ...questionAskAlias,
        translation: questionAskAlias.translation?.filter((v, idx) => idx !== index)
      }
    })
  }

  private renderLanguageSelect = (index: number) => (
    <LanguageConsumer>
      {({ languages }) => {
        if (!languages) return null
        const value = this.getFieldValue(`translation.${index}.language_id`, 'questionAskAlias')

        return (
          <>
            <Select
              placeholder="Language"
              style={{
                width: '85%'
              }}
              options={languages.filter(v => v.id !== undefined).map(v => {
                return {
                  label: v.name,
                  value: v.id
                }
              }) as any}
              value={value > 0 ? value : undefined}
              onChange={(value) => this.onFieldsChange({target: { name: `translation.${index}.language_id`, value }}, 'questionAskAlias')}
            />

            <Button
              type="dashed"
              shape="circle"
              size="small"
              onClick={() => this.handleRemoveTranslation(index)}
              style={{
                marginLeft: 5
              }}
            >
              <DeleteOutlined />
            </Button>
          </>
        )
      }}
    </LanguageConsumer>
  )

  private renderTranslation = () => {
    const { questionAskAlias } = this.state

    return (
      <Space
        direction="vertical"
      >
        {
          questionAskAlias.translation?.map((v, index) => {
            return (
              <Space
                direction="vertical"
                key={`translation-${index}`}
                style={{
                  minHeight: 120,
                  minWidth: 200
                }}
              >
                {
                  this.renderLanguageSelect(index)
                }
      
                {
                  v.language_id > 0 ? (
                    <Input.TextArea
                      placeholder="Question Alias"
                      name={`translation.${index}.ask_alias`}
                      value={v.ask_alias}
                      onChange={(ev: any) => this.onFieldsChange(ev, 'questionAskAlias')}
                    />
                  ) : null
                }
              </Space>
            )
          })
        }
      </Space>
    )
  }

  render() {
    const { question, onSave } = this.props
    const { questionAskAlias } = this.state
    const value: string = questionAskAlias.ask_alias || question.ask_alias || ''

    return (
      <div>
        <Input
          type="text"
          name="ask_alias"
          defaultValue={value}
          onChange={(ev: any) => this.onFieldsChange(ev, 'questionAskAlias')}
        />

        <Divider />

        <Collapse>
          <Collapse.Panel
            header="Translation"
            key="translation"
            extra={(
              <Button
                type="dashed"
                shape="circle"
                size="small"
                onClick={this.handleAddTranslation}
              >
                <PlusOutlined />
              </Button>
            )}
          >
            {this.renderTranslation()}
          </Collapse.Panel>
        </Collapse>

        <Divider />

        <Button
          type="primary"
          disabled={value.length === 0}
          onClick={() => onSave(question, questionAskAlias)}
          block
        >
          Save
        </Button>
      </div>
    )
  }
}
